import React, { Component } from 'react';
import * as _ from "lodash";
import ReactTooltip from 'react-tooltip';
import axios from "axios";
import compareValues from './SortValue.js';


function CustomComp(props) {

  return <div>
    <span className="toolTipHeader">Employees in this Cost Center :</span>
    <ul className="accorCol accorcol1">{props.dataTip != null && props.dataTip.slice(0, Math.ceil(props.dataTip.length / 2)).map(it => { return <li>{it}</li> })}</ul>
    <ul className="accorCol accorcol2">{props.dataTip != null && props.dataTip.slice(Math.ceil(props.dataTip.length / 2)).map(it => { return <li>{it}</li> })}</ul>
  </div>;
}
class HeadCountCostCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      HeadCountCCItemData: [],
      sessionId: '',
      headCountCCcode: '',
      headCountCCname: '',
      leveldown: false,
      isMandatory: false,
      selectedvalue: '',
      isLoaded: false,
      isDisplaylevelupdown: false,
      selectedlevelhcc: '',
      openItem: 0,
      nonUsedKey: null
    }
  }
  async  componentDidMount() {

    if (this.props.headcountCCcode != '') {
      this.setState({ headCountCCcode: this.props.headcountCCcode, headCountCCname: this.props.headCountCCName, selectedvalue: this.props.headcountCCcode, selectedlevelhcc: this.props.selectedlevelHCC })
    }

    if (this.props.mngwwid != '' && this.props.locationreferenceID != '') {
      await axios({
        method: 'POST',
        url: process.env.REACT_APP_WORKDAY_API_URL + 'getHeadCountCC',
        headers: {
          'apiKey': process.env.REACT_APP_WORKDAY_API_KEY,
          'clientKey': process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
          'Content-Type': 'application/json'
        },
        data: {
          "sessionId": this.props.sessionID,
          "managerWWID": this.props.mngwwid,
          "locationCode": this.props.locationreferenceID,
          "leCode": this.props.lecode,
          "headCountMRCCode": this.props.headCountMRCCode
        }
      }).then((res) => {
        this.setState({
          HeadCountCCItemData: res.data.headCountCostCenterList,
          isLoaded: true,
        });
      }).catch((error) => {
        //on error
        // alert("There is an error in API call mngid.");
      });
    }
    else {

    }
    if (this.state.HeadCountCCItemData.length > 0) {
      const checkleveldownarr = this.state.HeadCountCCItemData.map((item) => { return (item.level) }).filter((val, id, array) =>
        array.indexOf(val) == id).filter(function (el) { return el != null && el != "" }).sort((a, b) => a - b)

      let checkthirdvalue = checkleveldownarr[2];

      if (checkthirdvalue != undefined) {
        if (checkthirdvalue == this.props.selectedlevelHCC) {
          this.setState({ leveldown: true })
        }
        else {
          this.setState({ leveldown: false })
        }
        this.setState({ isDisplaylevelupdown: true })
      }
      else {
        this.setState({ isDisplaylevelupdown: false })
      }
    }
    //console.log("Selected Level:-", this.props.selectedlevelHCC)

  }
  SetWidth = () => {
    var header = document.querySelectorAll('.accordionheader');
    for (var i = 0; i < header.length; i++) {
      header[i].nextSibling.style.width = (this.DimensionWidth(header[i].parentElement) - this.DimensionWidth(header[i].previousSibling) - this.DimensionWidth(header[i]) - 20) + "px";
    }
  }



  DimensionWidth = (elmID) => {
    var elmHeight, elmMargin, elm = elmID;
    if (document.all) {// IE
      elmHeight = elm.offsetWidth;
      elmMargin = parseInt(elm.currentStyle.marginLeft, 10) + parseInt(elm.currentStyle.marginRight, 10);
    } else {// Mozilla
      elmHeight = elm.offsetWidth;
      elmMargin = parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-left')) + parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-right'));
    }
    return (elmHeight + elmMargin);
  }
  headcountcostcenter = (payrollcostcenteritemdata) => {
    if (payrollcostcenteritemdata.length > 0) {
      let headcountCCitemdataSort = payrollcostcenteritemdata.sort(compareValues('headCountCostCenterCode'));
      const leveluparr = headcountCCitemdataSort.map((item) => { return (item.level) }).filter((val, id, array) =>
        array.indexOf(val) == id).filter(function (el) { return el != null && el != "" }).sort((a, b) => a - b)

      let secondvalue = leveluparr[1];
      //console.log("leveluparr",leveluparr)    
      //console.log("secondvalue",secondvalue)       
      if (secondvalue != undefined) {
        return (
          this.getMergedEmployees(headcountCCitemdataSort.filter(it => { return it.level <= secondvalue }))
            .map((item) =>
              <li key={item.headCountCostCenterCode} value={item.headCountCostCenterCode}

                className={this.state.selectedvalue == item.headCountCostCenterCode && this.state.selectedlevelhcc == item.level ? 'lilist select-search-box__row lelist changebgcolor'
                  : 'lilist select-search-box__row lelist'}
                onClick={(e) => { this.handleCheck(item.headCountCostCenterCode, item.headCountCostCenterName, item.level) }}>
                <div className="accordionrowheader">
                  <span className="leradiospan">
                    <input type="radio" name="radio"
                      checked={this.state.headCountCCcode === item.headCountCostCenterCode && this.state.selectedlevelhcc == item.level}
                      id={item.headCountCostCenterCode} value={item.headCountCostCenterName}
                      onChange={(e) => { this.handleCheck(item.headCountCostCenterCode, item.headCountCostCenterName, item.level) }}>
                    </input>
                  </span>
                  <span className="accordionheader" title={item.headCountCostCenterName}>{item.headCountCostCenterCode} - {item.headCountCostCenterName}</span>
                  <span className="hoverlelist" style={{ float: "right" }} onClick={(e) => { this.setState({ openItem: this.state.openItem === item.headCountCostCenterCode ? 0 : item.headCountCostCenterCode }); e.stopPropagation(); }}>
                    {this.sortemployee(item.employees)} <span> <i className={this.state.openItem === item.payrollCostCenterCode ? "up" : "down"}></i></span>
                  </span>
                </div>
                <div className="accordionrowcontet">{this.state.openItem === item.headCountCostCenterCode ? <CustomComp dataTip={item.employees.map(it => { return it.name })} /> : ''}</div>
              </li>
            )
        )
      }
      else {
        return (
          headcountCCitemdataSort.map((item) =>
            <li key={item.headCountCostCenterCode} value={item.headCountCostCenterCode}

              className={this.state.selectedvalue == item.headCountCostCenterCode && this.state.selectedlevelhcc == item.level ? 'lilist select-search-box__row lelist changebgcolor'
                : 'lilist select-search-box__row lelist'}
              onClick={(e) => { this.handleCheck(item.headCountCostCenterCode, item.headCountCostCenterName, item.level) }}>
              <div className="accordionrowheader">
                <span className="leradiospan">
                  <input type="radio" name="radio"
                    checked={this.state.headCountCCcode === item.headCountCostCenterCode && this.state.selectedlevelhcc == item.level}
                    id={item.headCountCostCenterCode} value={item.headCountCostCenterName}
                    onChange={(e) => { this.handleCheck(item.headCountCostCenterCode, item.headCountCostCenterName, item.level) }}>
                  </input>
                </span>
                <span className="accordionheader" title={item.headCountCostCenterName}>{item.headCountCostCenterCode} - {item.headCountCostCenterName}</span>
                <span className="hoverlelist" style={{ float: "right" }} onClick={(e) => { this.setState({ openItem: this.state.openItem === item.headCountCostCenterCode ? 0 : item.headCountCostCenterCode }); e.stopPropagation(); }}>
                  {this.sortemployee(item.employees)} <span> <i className={this.state.openItem === item.payrollCostCenterCode ? "up" : "down"}></i></span>
                </span>
              </div>
              <div className="accordionrowcontet">{this.state.openItem === item.headCountCostCenterCode ? <CustomComp dataTip={item.employees.map(it => { return it.name })} /> : ''}</div>
            </li>
          )
        )
      }


    }
  }
  headcountcostcenterleveldown = (payrollcostcenteritemdata) => {


    if (payrollcostcenteritemdata.length > 0) {
      let headcountCCitemdatadownSort = payrollcostcenteritemdata.sort(compareValues('headCountCostCenterCode'));
      const leveldownarr = headcountCCitemdatadownSort.map((item) => { return (item.level) }).filter((val, id, array) =>
        array.indexOf(val) == id).filter(function (el) { return el != null && el != "" }).sort((a, b) => a - b)

      let thirdvalue = leveldownarr[2];
      //let thirdvalue=payrollcostcenteritemdata.sort((a, b) => { return parseFloat(a.level) - parseFloat(b.level)})[3];

      if (thirdvalue != undefined) {
        return (
          this.getMergedEmployees(headcountCCitemdatadownSort.filter(it => { return it.level == thirdvalue }))
            .map((item) =>
              <li key={item.headCountCostCenterCode} value={item.headCountCostCenterCode}

                className={this.state.selectedvalue == item.headCountCostCenterCode && this.state.selectedlevelhcc == item.level ? 'lilist select-search-box__row lelist changebgcolor'
                  : 'lilist select-search-box__row lelist'}
                onClick={(e) => { this.handleCheck(item.headCountCostCenterCode, item.headCountCostCenterName, item.level) }}>
                <div className="accordionrowheader">
                  <span className="leradiospan">
                    <input type="radio" name="radio"
                      checked={this.state.headCountCCcode === item.headCountCostCenterCode && this.state.selectedlevelhcc == item.level}
                      id={item.headCountCostCenterCode} value={item.headCountCostCenterName}
                      onChange={(e) => { this.handleCheck(item.headCountCostCenterCode, item.headCountCostCenterName, item.level) }}>
                    </input>
                  </span>
                  <span className="accordionheader" title={item.headCountCostCenterName}>{item.headCountCostCenterCode} - {item.headCountCostCenterName}</span>
                  <span className="hoverlelist" style={{ float: "right" }} onClick={(e) => { this.setState({ openItem: this.state.openItem === item.headCountCostCenterCode ? 0 : item.headCountCostCenterCode }); e.stopPropagation(); }}>
                    {this.sortemployee(item.employees)} <span> <i className={this.state.openItem === item.payrollCostCenterCode ? "up" : "down"}></i></span>
                  </span>
                </div>
                <div className="accordionrowcontet">{this.state.openItem === item.headCountCostCenterCode ? <CustomComp dataTip={item.employees.map(it => { return it.name })} /> : ''}</div>
              </li>
            )
        )

      }

    }
  }
  getMergedEmployees = (inputArray) => {
    const groupedJson = inputArray.reduce((rv, x) => {
      (rv[x["headCountCostCenterCode"]] = rv[x["headCountCostCenterCode"]] || []).push(x);
      return rv;
    }, {});
    const groupedArray = Object.keys(groupedJson).map(key => groupedJson[key]);
    const toMerge = groupedArray.filter(d => d.length > 1)
    const toRetain = groupedArray.filter(d => d.length == 1)
    let finalArray = []
    toMerge.map(arr => {
      let newData = {
        headCountCostCenterCode: arr[0].headCountCostCenterCode,
        headCountCostCenterName: arr[0].headCountCostCenterName,
        level: arr[0].level,
        employees: []
      }
      let emplArray = []
      arr.map(d => {

        emplArray = emplArray.concat(d.employees)
      })

      let uniqeEmployee = []
      emplArray.filter(function (item) {
        var i = uniqeEmployee.findIndex(x => x.name == item.name);
        if (i <= -1) {
          uniqeEmployee.push({ name: item.name });
        }
        return null;
      });
      console.log('emplArray', uniqeEmployee)
      newData.employees = uniqeEmployee
      finalArray.push(newData)
    })
    toRetain.map(data => {
      finalArray.push(data[0])
    })
    finalArray = finalArray.sort(compareValues('headCountCostCenterCode'));
    return finalArray
  };
  sortemployee = (employee) => {
    const sortedemployee = employee.sort((a, b) => a.name.localeCompare(b.name))
    return sortedemployee.length === 0 ? '' :
      sortedemployee.length === 1 ? sortedemployee[0].name :
        sortedemployee.length === 2 ? sortedemployee[0].name + ' & ' + sortedemployee[1].name :
          sortedemployee.length === 3 ? sortedemployee[0].name + ' , ' + sortedemployee[1].name + ' & ' + '1 other' :
            sortedemployee.length > 3 ? sortedemployee[0].name + ' , ' + sortedemployee[1].name + ' & ' + (sortedemployee.length - 2) + '  others' :
              ''
  }

  handleCheck = (id, val, level) => {
    this.setState({ headCountCCcode: id, headCountCCname: val, selectedvalue: id, selectedlevelhcc: level, openItem: 0 })
  }
  handleHeadCountCCData = () => {
    if (this.state.headCountCCcode != '' && this.state.headCountCCcode != undefined) {
      // console.log(this.state.headCountCCcode)
      this.props.onclickheadCountCCNext(this.state.headCountCCcode, this.state.headCountCCname, this.state.selectedlevelhcc);
      this.setState({ isMandatory: false })
    }
    else {
      this.setState({ isMandatory: true })
    }

  }
  handleHeadCountCCDataBack = () => {
    this.props.onclickHeadCountCCBack();
  }
  showleveldown = () => {
    this.setState({ leveldown: !this.state.leveldown })
    //this.forceUpdate();
    this.setState({ nonUsedKey: Date.now() });
  }
  render() {
    window.addEventListener('resize', this.SetWidth);
    this.SetWidth();

    return (
      <div>
        {this.state.isLoaded ?
          <div className="accordionlist">
            <h4 className="listheader">Please select a recommended <span className="listheadertext">Headcount Cost Center (CC):</span></h4>
            <ul className='ulist'>
              {this.state.leveldown === false ? this.headcountcostcenter(this.state.HeadCountCCItemData) : ''}
              {this.state.leveldown === true ? this.headcountcostcenterleveldown(this.state.HeadCountCCItemData) : ''}
              {this.state.isDisplaylevelupdown === true ? <li className="showlevelupdowntoggle" onClick={this.showleveldown}><span> {this.state.leveldown === true ? 'Show me one level up' : 'Show me one level down'}</span></li> : ''}
              <li className={this.state.selectedvalue == "noa" ? 'lenoneoftheabove changebgcolor' : 'lenoneoftheabove'}
                onClick={(e) => { this.handleCheck("noa", "noa", "noa") }} >
                <span className="leradiospan"><input type="radio" id="noa"
                  name="radio" value="noa" checked={this.state.headCountCCcode === "noa"}
                  onChange={(e) => { this.handleCheck("noa", "noa", "noa") }}></input></span>
                <span title="None of the above">None of the above</span></li>
            </ul>
          </div>
          : <div className='dataLoader'>Loading data please wait...</div>}
        {this.state.isMandatory === true ?
          <label className="MandatoryFields">Please select a recommended Headcount Cost Center</label> : ''}
        {this.state.isLoaded ?
          <div className='last-column rowhead lebtn'>
            <div className="nextbtn leback"> <input type="submit" value="< Back"
              className="btncls" onClick={this.handleHeadCountCCDataBack} /></div>
            <div className="nextbtn lenext"> <input type="submit" value="Next >"
              onClick={this.handleHeadCountCCData}
              className="btncls" /></div>
          </div> : ''}
      </div>
    );


  }
}

export default HeadCountCostCenter;